export enum RequestStatusType {
  EDITING = "in_editation",
  SAVED = "request_saved",
  SUBMITTED = "submitted",
  CANCELED_BY_NEW_CUSTOMER = "refused_by_new_customer",
  CANCELED_BY_OLD_CUSTOMER = "cancelled_by_old_customer",
  CANCELED_BY_OPERATOR = "cancelled_by_operator",
  ACCEPTED = "accepted",
  EXPIRED_SUBMITTED = "expired_submitted",
  EXPIRED_UNFINISHED = "expired_unfinished",
  FINISHED = "finished",
  REJECTED = "rejected",
  FOR_APPROVAL = "for_approval",
}
